export default __webpack_public_path__ + "static/service_floor@2x-c3acc158e8ba243baf86017b5e1904fb.jpg";